import { ReactComponent as GoldenArrow } from "../../assets/images/svg/arrowDownGolden.svg";
import PopupMenu from "../PopupMenu/PopupMenu";
import { useRef, useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

const GoldenDropDown = ({
  heading,
  selectedMember,
  ReportMenuContent,
  reportsMenuOpen,
  setReportsMenuOpen,
  position,
  showArrow,
  showPopup,
  isDisabled,
  dropDownContainerClass,
  disabledPopup,
  popupMenuClass,
  popUpId = "",
  popUpRole = "",
  ariaHasPopUp = "",
  // ariaExpanded = false,
  ariaControls = "",
}) => {
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const ref = useRef(null);
  const selectedTextRef = useRef(null);

  const onClickOutside = () => {
    setReportsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    if (selectedTextRef?.current) {
      setIsTextOverflowing(
        selectedTextRef?.current?.scrollWidth >
          selectedTextRef?.current?.clientWidth
          ? true
          : false,
      );
    }
  }, [heading, selectedTextRef?.curren]);

  return (
    <>
      {isDisabled ? (
        <div
          className={`${
            dropDownContainerClass || ""
          } dropdown_btn is-disabled blueBorderColor`}
          role="button"
          aria-disabled="true"
          tabIndex={-1}
        >
          <p className="selected_text blueTextColor">
            {heading?.length > 19 && heading !== "No Sub Asset Classes"
              ? `${heading?.slice(0, 19)}...`
              : heading}
          </p>
        </div>
      ) : showPopup === false ? (
        <div className={`${dropDownContainerClass || ""} dropdown_btn`}>
          {isTextOverflowing ? (
            <Marquee speed={24} pauseOnHover gradient={false}>
              <p className="selected_text marquee-text">{heading}</p>
            </Marquee>
          ) : (
            <p
              className="selected_text"
              ref={selectedTextRef}
              style={{ width: "calc(100% - 23px)", overflowX: "hidden" }}
            >
              {heading}
            </p>
          )}
        </div>
      ) : (
        <div ref={ref} style={{ position: "relative" }}>
          <PopupMenu
            MenuContent={ReportMenuContent}
            open={reportsMenuOpen}
            setOpen={setReportsMenuOpen}
            position={position}
            showArrow={showArrow}
            disabledPopup={disabledPopup}
            popupMenuClass={popupMenuClass}
            id={popUpId}
            role={popUpRole}
            ariaHasPopUp={ariaHasPopUp}
            ariaExpanded={reportsMenuOpen}
            ariaControls={ariaControls}
          >
            <div className={`${dropDownContainerClass || ""} dropdown_btn`}>
              {isTextOverflowing ? (
                <Marquee speed={24} pauseOnHover gradient={false}>
                  <p className="selected_text marquee-text">{heading}</p>
                </Marquee>
              ) : (
                <p
                  className="selected_text"
                  ref={selectedTextRef}
                  style={{ width: "calc(100% - 23px)", overflowX: "hidden" }}
                >
                  {heading}
                </p>
              )}
              {!disabledPopup ? (
                <div
                  className={`golden_down_arrow ${
                    reportsMenuOpen ? "is-active" : ""
                  }`}
                >
                  <GoldenArrow />
                </div>
              ) : (
                <></>
              )}
            </div>
          </PopupMenu>
        </div>
      )}
    </>
  );
};

export default GoldenDropDown;
